import {
  PRODUCT_API,
  PRODUCT_API_SEARCH,
  PRODUCT_API_SEARCH_LIST,
  PRODUCT_API_SORT,
} from "shared/constants/api-endpoint";
import { RemovedEntityModel } from "shared/models/removed-entity-model";
import { UpdatedSortEntityModel } from "shared/models/updated-sort-entity-model";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import {
  SearchProductRequestModel,
  ProductModel,
  ProductAndCommentModel,
  AddUpdateProductModel,
} from "./product.models";

export const searchProductApi = async (
  searchProductRequestModel: SearchProductRequestModel,
  langCode?: string
) => {
  const createResponse = await apiClient.postHttp<PagedResult<ProductModel>>(
    `${PRODUCT_API_SEARCH}`,
    searchProductRequestModel,
    { params: { langCode } }
  );
  return createResponse;
};

export const searchListProductApi = async (
  searchProductRequestModel: SearchProductRequestModel,
  langCode?: string
) => {
  const createResponse = await apiClient.postHttp<ProductModel[]>(
    `${PRODUCT_API_SEARCH_LIST}`,
    searchProductRequestModel,
    { params: { langCode } }
  );
  return createResponse;
};

export const updateSortProductApi = async (
  updatedSortModel: UpdatedSortEntityModel<number>[]
) => {
  const response = await apiClient.postHttp(
    `${PRODUCT_API_SORT}`,
    updatedSortModel
  );
  return response;
};

export const getProductByIdApi = async (id: number, langCode?: string) => {
  return await apiClient.getHttp<ProductModel>(`${PRODUCT_API}/${id}`, {
    params: { langCode },
  });
};

export const getAllVariationsApi = async (id: number, langCode?: string) => {
  return await apiClient.getHttp<ProductModel[]>(
    `${PRODUCT_API}/${id}/variations`,
    { params: { langCode } }
  );
};

export const updateProductApi = async (
  model: AddUpdateProductModel,
  langCode?: string
) => {
  const response = await apiClient.putHttp(`${PRODUCT_API}`, model, {
    params: { langCode },
  });
  return response;
};

export const addProductApi = async (
  model: AddUpdateProductModel,
  langCode?: string
) => {
  const response = await apiClient.postHttp<number>(`${PRODUCT_API}`, model, {
    params: { langCode },
  });
  return response;
};


export const removeProduct = async (removedModel: RemovedEntityModel<number>) => {
  const response = await apiClient.postHttp(
    `${PRODUCT_API}/remove_list`,
    removedModel
  );
  return response;
};


export const getProductHasNewCommentApi = async (
  page: number = 1,
  pageSize: number = 50
) => {
  return await apiClient.getHttp<PagedResult<ProductAndCommentModel>>(
    `${PRODUCT_API}/has_new_comments?page=${page}&pageSize=${pageSize}`
  );
};
